import * as React from "react";
import { Spinner } from "../ui/Spinner";
import { Icon } from "../ui/icons";
import { newID } from "../utils/unique";
import { useLifecycle } from "../hooks/useLifecycle";

export interface UploadState {
	file: File,
	progressPercent: number,

	data?: string,
	
	error?: string,

	id?: number, // db id when have it
}

export function FileUpload(props: {
	multiple: boolean,
	
	disabled?: boolean,

	onChange?: (files: FileList) => void,
}) {

	function handleChange(e: any) {
		if (props.onChange) {
			props.onChange(e.target.files);
		}
	}

	return (
		<div className="file-upload">
			<input
				type="file"
				
				multiple={props.multiple}

				onChange={handleChange}

				disabled={props.disabled}
			/>

			{/* <FileList files={files} /> */}

		</div>
	);

} 


function FileDetails(props: {
	file: UploadState,

	onClick?: (file: UploadState) => void,
}) {

	const {
		lastModified,
		name,
		size,
		type,
	} = props.file.file;


	var szTag = null;
	if (size < 100000) {
		szTag = <div className="">Small</div>;
	} else if (size < 500000) {
		szTag = <div className="">Medium</div>;
	} else {
		szTag = <div className="">Large</div>;
	}

	const spinner = 
		(props.file.progressPercent < 100) ?
		<Spinner size="small" />
		: null;

	const err = 
		(props.file.error) ?
		<div className="bg-error text-inverse">{JSON.stringify(props.file.error)}</div>
		: null;

	const complete = 
		(props.file.progressPercent === 100) ?
		<div className="bg-success text-inverse"><Icon type="tick" />Complete</div>
		: null;

	const isComplete = (props.file.progressPercent === 100) ? " is-complete" : "";

	function handleClick() {
		if (props.onClick) props.onClick(props.file);
	}

	return (
		<div className={"file-details" + isComplete} onClick={handleClick}>
			<div className="flex horiz tags">

				<div className="flex vert">
					<div>{name} {szTag}</div>
				</div>

				{spinner}

				{err}

				{complete}

			</div>
		</div>
	)
}


function FileList(props: {
	files: UploadState[],

	onClick?: (file: UploadState) => void,
}) {

	const {
		files,
	} = props;

	var content = null;

	if (files && files.length > 0) {
		const items = [];

		for(var i=0;i<files.length;i++) {
			const f = files[i];

			items.push(
				<FileDetails
					key={i}
					file={f}
					onClick={props.onClick}
				/>
			);
		}

		content = 
			<div>
				{items}
			</div>
			;

	} else {
		content = "Choose the files to upload";
	}

	return (
		<div className="file-list">
			{content}
		</div>
	)

}

export function AdvancedFileUpload(props: {
	multiple: boolean,

	onStartUpload: (fileState: UploadState) => Promise<any>,
	onFileClick?: (file: UploadState) => void,

	onUploadComplete: (result: any) => void,
}) {
	
	const lifecycle = useLifecycle();

	const [state, setState] = React.useState([] as UploadState[]);

	const [, refresh] = React.useState({});
	const [uploadID, setUploadID] = React.useState("");

	React.useEffect(function add() {

		for(var i=0;i<state.length;i++) {

			// kick off the reading of the file
			readFile(state[i]);

		}

		return function remove() {

		};
	}, [state]);


	function reset() {
		if (!lifecycle.isMounted) return;

		setState([]);
		setUploadID(newID());
	}

	function checkAllDone() {
		// are there any files left?
		for(var i=0;i<state.length;i++) {
			if (state[i].progressPercent < 100) return; // still something uploading
		}

		// everything was done, so set a timer for auto reset
		setTimeout(() => {
			reset();
		}, 2500);

	}

	function readFile(fileState: UploadState) {
		var reader = new FileReader();

		reader.addEventListener("load", function () {
			if (!lifecycle.isMounted) return;

			const data = reader.result as string;
			const matches = data.match(/^data:([A-Za-z-+\/]+);base64,(.+)$/);
			if (matches) {
				fileState.data = matches[2];
			}

			var uploadPromise = null;
			if (props.onStartUpload) {
				uploadPromise = props.onStartUpload(fileState);
			}

			if (uploadPromise) {

				uploadPromise.then((result: any) => {
					if (!lifecycle.isMounted) return;

					debugger;
					fileState.progressPercent = 100;
					if (result.id) fileState.id = result.id;
					refresh({});

					checkAllDone();

					if (props.onUploadComplete) {
						props.onUploadComplete(result);
					}

				}).catch((reason) => {
					if (!lifecycle.isMounted) return;

					fileState.error = reason;
					refresh({});

					checkAllDone();

				});

			}
		}, false);

		reader.readAsDataURL(fileState.file);
	}


	
	function handleChange(files: FileList) {

		const newState = [];
		for(var i=0;i<files.length;i++) {
			const fileState = {
				file: files[i],
				progressPercent: 0,
			};

			newState.push(fileState);
		}

		setState(newState);

	}






	var fileList = null;
	if (state.length > 0) {
		fileList = (
			<FileList
				files={state}
				onClick={props.onFileClick}
			/>
		);
	}

	return (
		<div className="fancy-file-upload">
			<FileUpload
				key={uploadID}

				multiple={props.multiple}
				onChange={handleChange}
				disabled={(state.length > 0)}
			/>
			{fileList}
		</div>	
	);

}


